import type { ReactNode } from "react";
import { masterPasswordHint } from "../../lib/masterPassword.js";
import { Checkbox, Field, SecretInput, StrengthMeter } from "../../ui/forms.js";

/** New master password + confirmation + the recovery acknowledgement. Shared by setup and first sign-in. */
export function NewPasswordFields(props: {
  readonly idPrefix: string;
  /** Policy minimum for the new password. */
  readonly minLength: number;
  readonly password: string;
  readonly confirm: string;
  readonly consent: boolean;
  readonly busy: boolean;
  readonly onPassword: (value: string) => void;
  readonly onConfirm: (value: string) => void;
  readonly onConsent: (value: boolean) => void;
}): ReactNode {
  return (
    <>
      <Field id={`${props.idPrefix}-password`} label="Neues Master-Passwort" hint={masterPasswordHint(props.minLength)}>
        <SecretInput
          id={`${props.idPrefix}-password`}
          autoComplete="new-password"
          value={props.password}
          onChange={(event): void => props.onPassword(event.target.value)}
          disabled={props.busy}
          revealLabel="Master-Passwort"
        />
      </Field>
      <StrengthMeter password={props.password} />
      <Field id={`${props.idPrefix}-confirm`} label="Master-Passwort wiederholen">
        <SecretInput
          id={`${props.idPrefix}-confirm`}
          autoComplete="new-password"
          value={props.confirm}
          onChange={(event): void => props.onConfirm(event.target.value)}
          disabled={props.busy}
          revealLabel="Wiederholung"
        />
      </Field>
      <Checkbox id={`${props.idPrefix}-consent`} checked={props.consent} onChange={props.onConsent}>
        Ich verstehe, dass niemand mein Master-Passwort zurückholen kann – auch der Administrator nicht. Vergesse ich es, hilft nur mein Notfall-Kit oder, falls mein Konto dafür registriert ist, die Admin-Wiederherstellung.
      </Checkbox>
    </>
  );
}
